import React from "react";
import { Stack } from "@mui/material";
import { GQLContentForm } from "@quales/data-access/graphql";
import Editor from "@monaco-editor/react";
import { useTheme } from "@quales/utils/theme";
import { CustomTypographyComponent } from "../ui/text";
import { validJson } from "../utils";
import debounce from "lodash.debounce";

const monacoEditorOptions = {
  minimap: {
    enabled: false,
  },
  automaticLayout: true,
};

interface UiSchemaFormProps {
  data?: GQLContentForm;
  onValueChange: (data: string) => void;
}

export const UiSchemaForm = ({ onValueChange, data }: UiSchemaFormProps) => {
  const [formValue, setFormValue] = React.useState<any>("");

  const [formErrors, setFormErrors] = React.useState([]);
  const theme = useTheme();

  React.useEffect(() => {
    if (data) {
      //@ts-ignore
      setFormValue(JSON.stringify(data.uiSchema, null, 2));
    }
  }, [data]);

  const debouncedSave = React.useCallback(
    debounce((nextValue: string) => onValueChange(nextValue), 1000),
    [onValueChange] // will be created only once initially
  );

  const onChange = (value: any, val) => {
    if (value && validJson(value)) {
      setFormValue(value);
      debouncedSave({
        value,
      });
    }
  };

  const handleEditorValidation = (markers) => {
    setFormErrors([...markers]);
  };

  return (
    <Stack height={600} overflow={"auto"} width="100%" id="UiSchemaForm">
      <Stack padding={2}>
        {formErrors &&
          formErrors.length > 0 &&
          formErrors.map((formError, index: number) => (
            <CustomTypographyComponent
              key={index}
              color={theme.appColors.error}
            >
              {formError.message} at line {formError.startLineNumber} at column{" "}
              {formError.startColumn}
            </CustomTypographyComponent>
          ))}
      </Stack>

      <Editor
        height="90vh"
        value={formValue}
        language="json"
        onValidate={handleEditorValidation}
        onChange={onChange}
        options={monacoEditorOptions}
      />
    </Stack>
  );
};

export default UiSchemaForm;
